<div class="loading-bar">
  <div
    [style.width.%]="currentProgress"
    class="loading-bar__progress"
    [class.loading-bar__progress--hide]="!isLoading"
  ></div>
</div>
